<template>
  <seller-list :processing_method="5"></seller-list>
</template>

<script>
import SellerList from '../seller-list'
export default {
  components: {
    SellerList
  }
}
</script>

<style lang="less">
</style>
